import { render, staticRenderFns } from "./RewardWidget.vue?vue&type=template&id=3b123935&"
import script from "./RewardWidget.vue?vue&type=script&lang=js&"
export * from "./RewardWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports